import http from "../http-common";
import constants from "../constants";

class BaseDataService {
  constructor(name) {
    this.moduleName = name
    this.http = http

  }

  getAll(limit = constants.pageLimit, page = 1) {
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return http.get(`/${this.moduleName}?limit=${limit}&page=${page}`);
  }

  get(id) {
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return http.get(`/${this.moduleName}/${id}`);
  }

  create(data) {
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return http.post(`/${this.moduleName}`, data);
  }

  update(id, data) {
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return http.put(`/${this.moduleName}/${id}`, data);
  }

  delete(id) {
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return http.delete(`/${this.moduleName}/${id}`);
  }

  deleteAll() {
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return http.delete(`/${this.moduleName}`);
  }

  findByTitle(title) {
    return http.get(`/${this.moduleName}?title=${title}`);
  }
}

export default BaseDataService;